/**
 * 该文件统一封装xhr请求
 * Created by xinqiao
 */
import Vue from 'vue'
import Axios from 'axios'
import { Message } from 'element-ui'
import routerApi from './api'

// 请求时的拦截器
Axios.interceptors.request.use(config => {
        return config
    },
    error => {
        return Promise.reject(error)
    })

Axios.interceptors.response.use(resp => {
        /*
        * @token
        *   200 成功
        *   400 未传
        *   401 无效或过期
        *   403 无权限
        */
        // Indicator.close()
        const {code, info, message} = resp.data
        if (code == 1) {
            return info
        } else {
            return Promise.reject(message)
        }
    },
    error => {
        return Promise.reject(error.resp)
    })


const httpServer = (opts, data) => {
    let params = opts.type == 'file' ? data  : Object.assign({}, data)
    let defaultOpts = {
        method: opts.method,
        baseURL: routerApi.baseUrl,
        url: opts.url,
        // timeout: 10000,
        params: params, // get
        data: params,   // post
        headers: {
            'Content-Type': opts.type == 'file' ? 'multipart/form-data' : 'application/json'
        },
    }
    if (opts.method === 'get') {
        delete defaultOpts.data
    } else {
        delete defaultOpts.params
    }
    let promise = new Promise(function (resolve, reject) {
        Axios(defaultOpts).then((res) => {
            resolve(res)
        }).catch((response) => {
            Message({
                message: response || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            reject(response)
        })
    })
    return promise
}
export default httpServer
